<template>
  <div class="inline-flex items-center lg:hidden">
    <aw-icon
      @click="toggle()"
      icon="search"
      class="w-5 h-5 text-gray-200 hover:text-gray-400 cursor-pointer"
    />
  </div>

  <div
    v-show="showForm"
    class="FormWrapper absolute left-0 right-0 !mx-0 rounded-md shadow-md bg-white"
  >
    <form class="flex items-center">
      <input
        ref="q"
        class="px-5 py-2 bg-transparent border text-sm w-full outline-none"
        type="text"
        :placeholder="$t('Search')"
        v-model="search"
        @keyup.enter.stop.prevent="onEnter"
      />
    </form>
  </div>
</template>

<script>
import HeaderSearchForm from '../../mixins/HeaderSearchForm'

export default {
  mixins: [HeaderSearchForm],
  data() {
    return {
      showForm: false
    }
  },
  watch: {
    $route (newVal, oldVal){
      if (newVal !== oldVal && !newVal.path.includes("search")) {
        this.showForm = false
      }
    }
  },
  methods: {
    toggle() {
      this.showForm = !this.showForm

      this.$nextTick(() => {
        if (this.showForm) {
          this.$refs.q.focus()
        }
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.FormWrapper {
  top: 40px;
  z-index: 12;
}
</style>
